var _path, _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarranty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 60,
    viewBox: "0 0 63 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0H33C49.5685 0 63 13.4315 63 30C63 46.5685 49.5685 60 33 60H30C13.4315 60 0 46.5685 0 30Z",
    fill: "#65D3E9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.2
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 5.5,
    width: 54,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 5.5,
    width: 54,
    height: 49,
    rx: 24.5,
    stroke: "#FAFAFA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5188_15103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6433 15.2148H41.5003V26.6434H44.3574V12.3574H15.7859V46.6434H31.5003V43.7859H18.6433V15.2148Z",
    fill: "#0B4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.357 28.3086L31.5 32.2375V35.6844C31.5 39.9926 33.934 43.9309 37.7871 45.8574L39.357 46.6422L40.927 45.8574C44.7801 43.9309 47.2141 39.9926 47.2141 35.6844V32.2375L39.357 28.3086ZM44.357 35.684C44.357 38.9309 42.5531 41.8496 39.6492 43.3016L39.357 43.4477L39.0648 43.3016C36.1609 41.8496 34.357 38.9305 34.357 35.684V34.0031L39.357 31.5031L44.357 34.0031V35.684Z",
    fill: "#0B4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.198 36.1879L35.7789 37.7938L39.4215 41.0137L43.8719 35.893L42.2551 34.4867L39.2223 37.9766L37.198 36.1879ZM21.5 19.5H38.643V22.357H21.5V19.5ZM21.5 26.643H32.9285V29.5H21.5V26.643ZM21.5 33.7855H27.2145V36.6426H21.5V33.7855Z",
    fill: "#0B4F5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5188_15103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(11.5 9.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarranty);
export default __webpack_public_path__ + "static/media/warranty.3ec40cd9c718224252cbce07e5d66eb1.svg";
export { ForwardRef as ReactComponent };